
import { Component, Vue, Prop } from 'vue-property-decorator';
import { useSimTableStore } from '@/shared/service';

@Component
export default class SimTable extends Vue {
  // props対応（オプショナル、後方互換性維持）
  @Prop({ required: false, default: null }) simTableData!: any;
  @Prop({ required: false, default: null }) simTableLoading!: boolean | null;
  @Prop({ required: false, default: null }) simTableError!: boolean | null;
  @Prop({ required: false, default: null }) simTableErrorMessage!: string | null;

  private simTableStore = useSimTableStore();

  get loading() {
    // propsがある場合はpropsを使用、ない場合はstoreから取得
    return this.simTableLoading !== null ? this.simTableLoading : this.simTableStore.loading;
  }

  get error() {
    return this.simTableError !== null ? this.simTableError : this.simTableStore.error;
  }

  get hasData() {
    return this.simTableStore.hasData;
  }

  get errorMessage() {
    return this.simTableErrorMessage !== null ? this.simTableErrorMessage : this.simTableStore.errorMessage;
  }

  get simData() {
    // propsがある場合はpropsを使用、ない場合はstoreから取得
    return this.simTableData !== null ? this.simTableData : this.simTableStore.simTable;
  }
}
